// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenuButton-cls1_KAU","cls2":"AccountMenuButton-cls2_Yvo AccountMenuButton-cls1_KAU"};